import { ComponentPropsWithoutRef } from 'react'

export function LogoYoutube20(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <path d="M8 13V7l5 3zm11.582-7.814a2.5 2.5 0 0 0-1.769-1.768C16.254 3 10 3 10 3s-6.254 0-7.814.418c-.86.23-1.538.908-1.768 1.768C0 6.746 0 10 0 10s0 3.254.418 4.813c.23.862.908 1.54 1.768 1.769C3.746 17 10 17 10 17s6.254 0 7.813-.418a2.5 2.5 0 0 0 1.769-1.769C20 13.254 20 10 20 10s0-3.254-.418-4.814" />
    </svg>
  )
}
